<script lang="ts">
	import { t } from "@hitit/hub/src/stores";

	//UI
	//Utils
	//Types
	//Props
	export let editmode = false;
	export let status = "";
	//Constants
	const applicationStatusTypes = ["PENDING", "APPROVED", "TERMINATED", "DRAFT"];
	//Variables
	//Functions
	//Do

</script>

{#if editmode}
	<div class="container">
		{#each applicationStatusTypes as appStatusType}
			<label t-id={appStatusType} class:selected={appStatusType === status}>
				{$t(`global.store_status.${appStatusType}`)}
				<input type="radio" bind:group={status} value={appStatusType} />
			</label>
		{/each}
	</div>
{:else}
	<div
		class="status"
		class:pending={status === 'PENDING'}
		class:approved={status === 'APPROVED'}
		class:terminated={status === 'TERMINATED'}
		class:draft={status === 'DRAFT'}>
		<span>{$t(`global.store_status.${status}`)}</span>
	</div>
{/if}

<!--  -->
<style lang="scss">
	@import "../../../../variables.scss";
	.container {
		display: flex;
		gap: 10px;
		flex-wrap: wrap;

		label {
			display: flex;
			align-items: center;
			padding: 4px 8px 5px 8px;
			box-sizing: border-box;
			border: 1px solid #bcbfc3;
			color: #6d6f76;
			font-size: 0.875rem;
			border-radius: 14px;

			&.selected {
				color: white;
				border: none;
				background-color: #6d6f76;
			}
			&:hover {
				cursor: pointer;
			}
		}
		input {
			display: none;
		}
	}

	div.status {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 4px 8px 5px 8px;
		border-radius: 14px;

		span {
				@include heightRelativeToFontSize(14);
			}

		&.pending {
			color: #46474b;
			background-color: #d8d9df;
		}

		&.approved {
			color: white;
			background-color: #6d6f76;
		}

		&.terminated {
			color: white;
			background-color: #f66d6c;
		}

		&.draft {
			color: #46474b;
			background-color: #bcbfc3;
		}
	}
	@include DesktopSize {
		.container {
			label {
				font-size: 1.25rem;
				border-radius: 17px;
				padding: 3px 12px 6px 12px;
			}
		}
		div.status {
			padding: 5px 12px;
			margin-top: 5px;
			height: 20px;

			span {
				@include heightRelativeToFontSize(20);
			}
		}
	}

</style>
